<template>
  <v-flex xs12 pa-0 ma-0>
    <v-card >
      <v-layout pa-0 ma-0 v-bind="binding">
        <v-flex xs12 lg9 pa-0 ma-0>
          <v-card-title style="{padding: {padding-top: 0px}}">
            <span class="grey--text" pa-0 ma-0>
              <h5>{{ value.title }}</h5>
            </span>
          </v-card-title>
          <v-card-text style="{padding-top: 0px}">
            <span>{{ value.description }}</span>
          </v-card-text>
        </v-flex>
        <v-flex xs12 lg3 pa-0 ma-0>
          <v-card-actions>
            <v-layout row justify-end>
              <v-flex xs12 lg12>
                <v-checkbox v-model="value.selected" label="I want this!" />
                <div v-if="value.selected==true">
                  <v-text-field
                    ref="count"
                    name="count"
                    v-model="value.count"
                    :rules="[() => !!value.count || 'This field is required']"
                    label="Number of meals"
                    type="integer"
                    required
                  />
                </div>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  watch: {
    value() {
      this.$emit('input', this.value);
    },
  },
  computed: {
    binding() {
      const binding = {};

      if (this.$vuetify.breakpoint.smAndDown) binding.column = true;

      return binding;
    },
  },
};
</script>

<style scoped>

h1 {
  text-align: center;
  font: 5rem sans-serif;
}
h2 {
  text-align: center;
  font: 3.5rem sans-serif;
}
h3 {
  text-align: center;
  font: 3rem sans-serif;
}
h4 {
  text-align: center;
  font: 2rem sans-serif;
}
h5 {
  text-align: center;
  font: 1.4rem sans-serif;
}
h6 {
  text-align: center;
  font: 1rem sans-serif;
}
</style>
